var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBudget = function SvgBudget(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 44,
    viewBox: "0 0 33 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9005 4.2927C20.9005 1.92184 18.9306 0 16.5005 0C14.0703 0 12.1005 1.92184 12.1005 4.2927H7.70044V8.5854H25.3006V4.2927H20.9005Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8005 29.5125H18.1504V32.732H19.8005C20.7104 32.732 21.4506 32.0098 21.4506 31.1222C21.4505 30.2346 20.7105 29.5125 19.8005 29.5125Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 23.0732C12.2902 23.0732 11.55 23.7954 11.55 24.683C11.55 25.5707 12.2902 26.2928 13.2001 26.2928H14.85V23.0733H13.2001V23.0732Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6002 8.58496V11.8045H4.40002V8.58496H0V43.9999H33.0003V8.58496H28.6002ZM19.8003 35.951H18.1502V38.6339H14.8502V35.951H13.2003C11.8802 35.951 10.5848 35.735 9.35014 35.3092L10.4501 32.2739C11.3305 32.5776 12.2559 32.7315 13.2003 32.7315H14.8502V29.512H13.2003C10.4709 29.512 8.25029 27.3456 8.25029 24.6827C8.25029 22.0198 10.4709 19.8534 13.2003 19.8534H14.8502V17.1704H18.1502V19.8534H19.8003C21.1205 19.8534 22.4157 20.0694 23.6505 20.4952L22.5505 23.5306C21.67 23.2269 20.7448 23.073 19.8003 23.073H18.1502V26.2925H19.8003C22.5298 26.2925 24.7503 28.4589 24.7503 31.1218C24.7503 33.7846 22.5298 35.951 19.8003 35.951Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.70044,
    y1: 0,
    x2: 23.9646,
    y2: -2.04416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 18.1504,
    y1: 29.5125,
    x2: 21.236,
    y2: 29.3185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 11.55,
    y1: 23.0732,
    x2: 14.6355,
    y2: 22.8794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 0,
    y1: 8.58496,
    x2: 30.8763,
    y2: 6.82103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBudget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/budget.ee0866beb846ee4d6ae0973574370f0d.svg";